import { createSlice } from "@reduxjs/toolkit";

interface State {
    tenancyName: string | null;
}
interface Action {
    type: string,
    payload: State
}

const tenantSlice = createSlice({
    name: "tenantSlice",
    initialState: {
        tenancyName: null,
    },
    reducers: {
        setTenancyName(state: State, action: Action) {
            state.tenancyName = action.payload.tenancyName;
        }
    }
});

export const { setTenancyName } = tenantSlice.actions;
export default tenantSlice.reducer;